import appConfig from '../config';

const locationsArray = appConfig.LOCATIONS || [];

export type Location = {
	name: string;
	cityId: string;
	path: string;
};

// TODO refactor .replace(/ /g, '_') may be better
export const stringToCode = (name: string) => name.toLowerCase().replace(/ /g, '');

export const LocationOptionsMap: Record<string, Location> = {
	...locationsArray?.reduce((acc, value) => {
		const key = stringToCode(value.cityId);
		acc[key] = value;

		return acc;
	}, {}),
	others: {
		name: 'Others',
		cityId: 'others',
		path: '',
	},
};

export const getOthersLocation = (): Location => LocationOptionsMap.others;

export const getDefaultLocation = (): Location => {
	const locations = Object.values(LocationOptionsMap);

	return locations[0];
};

// if no filter is passed, then return default location
// if filter is passed, then find the location based on the filter
// if no location is found, then return 'others' location
export const getLocation = <T extends Location>(
	filter?: { id?: string; name?: string; path?: string },
	defaultValue: T = getDefaultLocation() as T
): Location | T => {
	if (!filter?.id && !filter?.name && !filter?.path) return defaultValue;

	let location: Location | undefined;

	if (filter.id) {
		location = Object.values(LocationOptionsMap).find((v) => v.cityId === filter.id);
	}

	if (filter.name) {
		location = Object.values(LocationOptionsMap).find((v) => stringToCode(v.name) === filter.name ? stringToCode(filter.name) : undefined);
	}

	if (filter.path) {
		location = Object.values(LocationOptionsMap).find((v) => v.path === filter.path);
	}

	return location ?? LocationOptionsMap.others;
};

// for server filter query - if 'others' is selected, then we don't want to send any cityId, so that we get all the results
export const getCityIdForFilter = (cityId: string): string | undefined =>
	cityId === 'others' ? undefined : cityId;
